/**
 * Mock Integrations
 * Base44 Core.InvokeLLM, Core.SendEmail, Core.GeneratePDF için mock implementasyonlar
 * Demo/geliştirme ortamı için
 */

/**
 * Mock LLM Response Generator
 * AI Lead Scout için sahte iş yeri verileri üretir
 */
export async function InvokeLLM({ prompt, response_json_schema, add_context_from_internet }) {
  console.log('[MockLLM] Prompt:', prompt.substring(0, 100) + '...');

  // Prompt'tan şehir ve branche çıkar
  const cityMatch = prompt.match(/in\s+([^,\n]+)/i) || prompt.match(/Ort:\s*([^\n]+)/i);
  const brancheMatch = prompt.match(/nach\s+([^-\n]+)/i) || prompt.match(/(\w+)-Restaurants/i) || prompt.match(/Branche:\s*([^\n]+)/i);

  const city = cityMatch ? cityMatch[1].trim() : 'München';
  const branche = brancheMatch ? brancheMatch[1].trim() : 'Restaurant';

  // Sahte iş yerleri oluştur
  const mockBusinesses = generateMockBusinesses(city, branche, 5 + Math.floor(Math.random() * 6));

  // Gecikme simülasyonu
  await new Promise(resolve => setTimeout(resolve, 1500 + Math.random() * 1000));

  return { businesses: mockBusinesses };
}

/**
 * Sahte iş yeri verileri üretir
 */
function generateMockBusinesses(city, branche, count) {
  const streetNames = [
    'Hauptstraße', 'Bahnhofstraße', 'Marktplatz', 'Schillerstraße', 'Goethestraße',
    'Berliner Straße', 'Münchner Straße', 'Karlstraße', 'Ludwigstraße', 'Maximilianstraße'
  ];

  const prefixes = {
    'Asiatische Küche': ['Golden Dragon', 'Asia Palast', 'Lotus Garden', 'Lucky Star', 'Bamboo House'],
    'Bowl/Smoothies': ['Green Bowl', 'Vitality Bar', 'Fresh & Healthy', 'Bowl Factory', 'Superfood Café'],
    'Burger': ['Burger Meister', 'Grill House', 'Patty King', 'BBQ Corner', 'Smoke House'],
    'Döner': ['Sultan Kebap', 'Anatolien Grill', 'Istanbul Döner', 'Marmara', 'Bosporus'],
    'Indische Küche': ['Taj Mahal', 'Bombay Palace', 'Curry House', 'Maharaja', 'Ganesha'],
    'Italienische Küche': ['La Piazza', 'Bella Italia', 'Trattoria Roma', 'Il Giardino', 'Pasta e Basta'],
    'Hotel': ['Grand Hotel', 'City Hotel', 'Park Hotel', 'Business Inn', 'Comfort Suites'],
    'Industrie': ['Catering Solutions', 'Großküche Plus', 'Food Service GmbH', 'Gastro Partner', 'Kitchen Pro'],
  };

  const names = prefixes[branche] || prefixes['Italienische Küche'];

  return Array.from({ length: count }, (_, i) => {
    const streetNum = Math.floor(Math.random() * 150) + 1;
    const plz = String(80000 + Math.floor(Math.random() * 1000));

    return {
      name: `${names[i % names.length]} ${city.split(' ')[0]}`,
      street: `${streetNames[Math.floor(Math.random() * streetNames.length)]} ${streetNum}`,
      postal_code: plz,
      city: city,
      phone: `+49 ${Math.floor(Math.random() * 900) + 100} ${Math.floor(Math.random() * 9000000) + 1000000}`,
    };
  });
}

/**
 * Mock Email Sender
 * E-posta gönderimini simüle eder
 */
export async function SendEmail({ to, subject, body, attachments = [] }) {
  console.log('[MockEmail] Sending to:', to);
  console.log('[MockEmail] Subject:', subject);
  console.log('[MockEmail] Body preview:', body.substring(0, 100) + '...');
  console.log('[MockEmail] Attachments:', attachments.length);

  // Gecikme simülasyonu
  await new Promise(resolve => setTimeout(resolve, 800));

  // Başarılı yanıt
  return {
    success: true,
    messageId: `mock_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    timestamp: new Date().toISOString(),
  };
}

/**
 * Mock PDF Generator
 * PDF oluşturma işlemini simüle eder
 */
export async function GeneratePDF({ html, filename }) {
  console.log('[MockPDF] Generating:', filename);
  console.log('[MockPDF] HTML length:', html.length);

  // Gecikme simülasyonu
  await new Promise(resolve => setTimeout(resolve, 500));

  // Base64 encoded "fake" PDF (aslında HTML döner)
  const base64Html = btoa(unescape(encodeURIComponent(html)));

  return {
    success: true,
    filename,
    pdf_content: base64Html,
    url: `data:text/html;base64,${base64Html}`,
  };
}

/**
 * Mock Integrations Export
 */
export const MockIntegrations = {
  Core: {
    InvokeLLM,
    SendEmail,
    GeneratePDF,
  },
};

export default MockIntegrations;
